import { z } from "zod";

// export const googleInput = z.object({
// 	code: z.string(),
// 	timezone: z.string().optional(),
// });

// export type GoogleInputDto = z.infer<typeof googleLoginInput>;

const baseLoginInput = z.object({
	timezone: z
		.string()
		.optional()
		.describe("The current timezone at user's location location"),
});

export const googleLoginInput = baseLoginInput.extend({
	auth: z.object({
		scheme: z.literal("google"),
		code: z.string().describe("The authorization code from the Google auth"),
	}),
});

export const emailLoginInput = baseLoginInput.extend({
	auth: z.object({
		scheme: z.literal("email"),
		email: z.string().describe("The email of the user that wants to sign in"),
		password: z
			.string()
			.describe("The plain text password of the user who wants to sign in"),
	}),
});

export const authTokens = z.object({
	accessToken: z.string(),
	refreshToken: z.string(),
});
export type AuthTokensDto = z.infer<typeof authTokens>;
